import store from '../store'
export const listenEvent = async () => {
  try {
    console.log('listenEvent')
    const provider = window.ethereum
    provider.on('disconnect', async () => {
      store.dispatch('disconnect')
    })
    provider.on('connect', async () => {
      console.log('connect')
    })
    provider.on('accountsChanged', (accounts) => {
      if (accounts.length > 0) {
        store.dispatch('setAccount', accounts[0])
      }
    })

    provider.on('chainChanged', (chainId) => {
      console.log(chainId)
    })
  } catch (ex) {
    console.warn(ex)
  }
}
